import React, { useContext } from 'react';
import { Group, Rect } from 'react-konva';
import { Html } from 'react-konva-utils';
import ReactPlayer from 'react-player/lazy';
import { ViewCardContext } from '../ViewCardContext';

interface Props {
  videoProps: any;
}

const Video: React.FC<Props> = ({ videoProps }) => {
  const { isCardOpened } = useContext(ViewCardContext);

  return (
    <Group draggable={false} x={videoProps.x} y={videoProps.y} id={videoProps.id} name={videoProps.name}>
      <Html transform>
        <div
          style={{
            position: 'absolute',
            width: videoProps.width,
            height: videoProps.height,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'black',
          }}
        >
          <ReactPlayer
            url={videoProps.src}
            width="100%"
            height="100%"
            controls
            playing={isCardOpened}
            style={{ pointerEvents: 'auto', objectFit: 'cover' }}
          />
        </div>
      </Html>
      <Rect width={videoProps.width} height={videoProps.height} />
    </Group>
  );
};

export default Video;
